import { render, staticRenderFns } from "./FederationBox.vue?vue&type=template&id=2f3645f8&scoped=true&"
import script from "./FederationBox.vue?vue&type=script&lang=js&"
export * from "./FederationBox.vue?vue&type=script&lang=js&"
import style0 from "./FederationBox.vue?vue&type=style&index=0&id=2f3645f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3645f8",
  null
  
)

export default component.exports